import React from 'react'
import './landing.css'
import Navbar from '../../Components/Navbar/Navbar'
import Hero from './Hero/Hero'
import About from './About/About'
import Services from './Services/Services'
import Program from './Program/Program'
import Groups from './Groups/Groups'
import Pricing from './Pricing/Pricing'
import Contact from './Contact/Contact'
import Footer from '../../Components/Footer/Footer'
import NavItems from '../../Components/Navbar/NavItems.json'

export default function LandingPage() {
  return (
    <div className="lp">
      <Navbar items={NavItems} />
      <main>
        <Hero/>
        <About/>
        <Services/>
        <Program/>
        <Groups/>
        <Pricing/>
        <Contact/>
      </main>
      <Footer/>
    </div>
  )
}
